import React from 'react';
import PropTypes from 'prop-types';
import {viewWrapper} from '../../viewWrapper';
import {BrowserRouter} from 'react-router-dom';
import tropic from '../../tropic';
import NavBar from '../../components/common/NavBar';
import Footer from '../../components/common/Footer';
import SimpleField from '@/js/components/common/SimpleField';
import { genericOnChangeCreator } from '@/js/formHelpers';
import { required } from '../../validators';
import { clone } from '@/js/util';
import '@/scss/components/Login.scss';


class Login extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.onSubmit = this.onSubmit.bind(this);

		this.state = {
			values: { compassID: '', password: '' },
			meta: {
				compassID: { touched: true, errorMessage: '' },
				password: { touched: true,  errorMessage: ''}
			},
			formSubmissionSuccessful: true,
			redirect: '',
			loggedIn: false,
			pageIsSubmittable: true
		};
	}

	validateCompassID(val) {
		return required(val, 'Compass ID');
	}

	validatePassword(val) {
		return required(val, 'Compass password');
	}

	validate(compassID, password) {
		let errors = {};
		if(!compassID) errors.compassID = this.validateCompassID(compassID);
		if(!password) errors.password = this.validatePassword(password);
		return errors;
	}

	onSubmit(e) {
		e.preventDefault();

		//validation
		let errors = this.validate(this.state.values.compassID, this.state.values.password);
		if(Object.keys(errors).length > 0) {
			this.setState(prevState => {
				let newState = clone(prevState);
				for (let metaKey in errors) {
					newState.meta[metaKey] = { errorMessage: errors[metaKey], touched: true};
				}
				return newState;
			});
		} else {
			tropic.fetch({
				url: `/api/login`,
				method: 'POST',
				body: JSON.stringify({'username': this.state.values.compassID, 'password': this.state.values.password})
			}).then((result) => {
				this.setState({
					redirect: result.redirect,
					formSubmissionSuccessful: result.formSubmissionSuccessful,
					loggedIn: result.loggedIn,
					pageIsSubmittable: false,
				});
				// force re-render 500ms later in case of multiple failed submissions
				setTimeout( ()=>{ this.setState({
					pageIsSubmittable: true
				});}, 500 );
			}).catch((error) => {
				this.setState({
					formSubmissionSuccessful: false,
					pageIsSubmittable: false,
				});
				setTimeout( ()=>{ this.setState({
					pageIsSubmittable: true
				});}, 500 );
			});
		}
	}

	render() {
		const baseUrl = 'Login';
		let isValid = this.state.formSubmissionSuccessful || (!this.state.pageIsSubmittable);
		if(/:\/\//.test(this.state.redirect)) {
			window.location = this.state.redirect;
		} else if(this.state.redirect.length > 0) {
			window.location.pathname = this.state.redirect;
		}

		// If props.appState.cognitoEnabled render a different screen
		let pageContent = (
			<div>
				<h2>Log In</h2>
				<div className={ isValid ? "errorMessage d-none" : "errorMessage alert alert-danger"}>
					<span>The ID/password combination entered is invalid. Try again.</span>
				</div>
				<div className='LoginCard card mb-3'>
					<div className='card-body'>
						<form onSubmit={this.onSubmit}>
							<SimpleField name="login"
								id="LoginForm compassID"
								label="Compass ID"
								type="text"
								maxLength={20}
								value={this.state.values.compassID}
								touched={this.state.meta.compassID.touched}
								errorMessage={this.state.meta.compassID.errorMessage}
								onChange={genericOnChangeCreator(this, 'compassID', this.validateCompassID)}
								onBlur={genericOnChangeCreator(this, 'compassID', this.validateCompassID)}
								validationIconClass="validationErrorIcon"
							/>
							<SimpleField name="password"
								id="LoginForm password"
								label="Password"
								type="password"
								maxLength={65}
								value={this.state.values.password}
								touched={this.state.meta.password.touched}
								errorMessage={this.state.meta.password.errorMessage}
								onChange={genericOnChangeCreator(this, 'password', this.validatePassword)}
								onBlur={genericOnChangeCreator(this, 'password', this.validatePassword)}
								validationIconClass="validationErrorIcon"
							/>
							<div className="loginMessage" className={ !this.state.loggedIn ? "loginMessage d-none" : "loginMessage"}>
								<span>Logging in...</span>
							</div>
							<div className='d-flex justify-content-between align-items-center'>
								<a href="/ResetPassword" className="pe-3">Forgot Password?</a>
								<input className="btn btn-primary btn-lg" type="submit" value="Log In" disabled={!this.state.pageIsSubmittable || this.state.loggedIn} />
							</div>
						</form>
					</div>
				</div>
			</div>
		);

		if (this.props.appState.cognitoEnabled === 'Y') {
			pageContent = (
				<h2 className="text-center mb-3">User must use their Single Sign-On Provider to Log In</h2>
			);
		}

		return (
			<BrowserRouter basename={baseUrl}>
				<div className='LoginView'>
					<NavBar loggedIn = {false} />
					<div className='container-fluid'>
						<div className='row'>
							<div className='LoginForm col-12 col-sm-8 col-md-6 col-lg-4 mx-auto'>
								{pageContent}
								{Footer}
							</div>
						</div>
					</div>

				</div>
			</BrowserRouter>
		);
	}
}

Login.propTypes = {
	// default view props
	appState: PropTypes.object.isRequired,
	loading: PropTypes.object,
	viewData: PropTypes.object
};

let LoginView = viewWrapper({
	enableIntercom: false
})(Login);


/* gives wrapped view component as an argument to a function
that does React.render(<App><View/></App>, MOUNT_NODE);*/

tropic.bootstrapView(LoginView);
